import AddressSwitcherBar from 'components/address-switcher-bar/AddressSwitcherBar.tsx'
import { Heading } from '@boltenergy-be/design-system'
import { useStoreSelector } from 'hooks/store.ts'
import { selectCurrentServiceContracts } from 'store/contact/slice.ts'
import { useTranslation } from 'react-i18next'
import TariffsLogbook from 'pages/app/tariffs/overview/components/tariffs-logbook/TariffsLogbook.tsx'
import CurrentTariffsCard from 'components/current-tariffs-card/CurrentTariffsCard.tsx'
import { UserTypes } from 'store/auth/types.ts'

const TariffsOverview = () => {
  // Redux
  const { electricity, gas } = useStoreSelector(selectCurrentServiceContracts)

  // i18n
  const { t } = useTranslation('tariffs')

  return (
    <>
      <AddressSwitcherBar />

      <CurrentTariffsCard {...{ electricity, gas }} view={UserTypes.SUPER_USER} />

      <section>
        <Heading as="h2" variant="h5" className="mb-400">
          {t(($) => $.logbook.title)}
        </Heading>

        <TariffsLogbook />
      </section>
    </>
  )
}

export default TariffsOverview
